import { supabase } from '../lib/supabase';

// Convert snake_case to camelCase
const toCamelCase = (obj) => {
  if (!obj) return obj;
  return {
    id: obj?.id,
    fullName: obj?.full_name,
    email: obj?.email,
    phone: obj?.phone,
    licenseNumber: obj?.license_number,
    licenseExpiry: obj?.license_expiry,
    experienceYears: obj?.experience_years,
    languages: obj?.languages || [],
    rating: obj?.rating,
    totalTrips: obj?.total_trips,
    avatar: obj?.avatar,
    avatarAlt: obj?.avatar_alt,
    status: obj?.status,
    hourlyRate: obj?.hourly_rate,
    dailyRate: obj?.daily_rate,
    bio: obj?.bio,
    createdBy: obj?.created_by,
    createdAt: obj?.created_at,
    updatedAt: obj?.updated_at,
  };
};

// Convert camelCase to snake_case
const toSnakeCase = (obj) => {
  return {
    full_name: obj?.fullName,
    email: obj?.email,
    phone: obj?.phone,
    license_number: obj?.licenseNumber,
    license_expiry: obj?.licenseExpiry,
    experience_years: obj?.experienceYears,
    languages: obj?.languages,
    rating: obj?.rating,
    total_trips: obj?.totalTrips,
    avatar: obj?.avatar,
    avatar_alt: obj?.avatarAlt,
    status: obj?.status,
    hourly_rate: obj?.hourlyRate,
    daily_rate: obj?.dailyRate,
    bio: obj?.bio,
  };
};

export const driverService = {
  async getAll() {
    const { data, error } = await supabase
      ?.from('drivers')
      ?.select('*')
      ?.order('rating', { ascending: false });

    if (error) throw error;
    return data?.map(toCamelCase) || [];
  },

  async getAvailable() {
    const { data, error } = await supabase
      ?.from('drivers')
      ?.select('*')
      ?.eq('status', 'available')
      ?.order('rating', { ascending: false });

    if (error) throw error;
    return data?.map(toCamelCase) || [];
  },

  async getById(id) {
    const { data, error } = await supabase
      ?.from('drivers')
      ?.select('*')
      ?.eq('id', id)
      ?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async create(driver) {
    const { data: { user } } = await supabase?.auth?.getUser();
    if (!user) throw new Error('Not authenticated');

    const { data, error } = await supabase
      ?.from('drivers')
      ?.insert({ ...toSnakeCase(driver), created_by: user?.id })
      ?.select()
      ?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async update(id, driver) {
    const { data, error } = await supabase
      ?.from('drivers')
      ?.update(toSnakeCase(driver))
      ?.eq('id', id)
      ?.select()
      ?.single();

    if (error) throw error;
    return toCamelCase(data);
  },

  async delete(id) {
    const { error } = await supabase?.from('drivers')?.delete()?.eq('id', id);
    if (error) throw error;
  },

  async checkAvailability(driverId, startDate, endDate) {
    const { data, error } = await supabase?.rpc('is_driver_available', {
      driver_uuid: driverId,
      check_start_date: startDate,
      check_end_date: endDate,
    });

    if (error) throw error;
    return data;
  },

  subscribeToChanges(callback) {
    const channel = supabase
      ?.channel('drivers')
      ?.on('postgres_changes', { event: '*', schema: 'public', table: 'drivers' }, (payload) => {
        callback(payload);
      })
      ?.subscribe();

    return () => supabase?.removeChannel(channel);
  },
};